import { OFFER_TYPE_TOUR, OFFER_TYPE_HOTEL } from 'constants/offer'
import { isBedbankOffer, isCruiseOffer, isTourV2Offer } from 'lib/offer/offerTypes'
import { IntlShape } from 'react-intl'

interface LabelElement {
  mainLabel: string
  subLabel?: string
}

export function getConfidenceLabels(intl: IntlShape, offer: App.Offer): Array<string> {
  const labels: Array<string> = []
  if (!offer) return labels

  if (offer.type === OFFER_TYPE_HOTEL && !!offer.daysBeforeCheckInChangesDisallowed) {
    labels.push(intl.formatMessage({
      id: 'Td7eTAqBLV',
      defaultMessage: 'Free date changes',
      description: 'Confidence label for hotels that allow free date changes',
    }))
  }

  labels.push(intl.formatMessage({
    id: '/NWri54xaw',
    defaultMessage: 'Curated by travel experts',
    description: 'Confidence label indicating offer is curated by travel experts',
  }))
  return labels
}

export function getLabels(
  offer: App.Offer | App.BedbankOffer | App.Tours.TourV2Offer | App.CruiseOffer,
  variationId?: string,
): LabelElement {
  if (!offer) return { mainLabel: '' }

  if (isBedbankOffer(offer) || offer.type === OFFER_TYPE_TOUR) {
    return { mainLabel: offer.name }
  }

  if (isTourV2Offer(offer)) {
    return { mainLabel: variationId && offer.variations[variationId] ? offer.variations[variationId].name : offer.name }
  }

  if (isCruiseOffer(offer)) {
    return { mainLabel: offer.name }
  }

  else {
    return { mainLabel: offer.property?.name ?? '', subLabel: offer.name }
  }
}
